module.exports = __webpack_public_path__ + "static/media/golfer-5-a.937bf635.png";